const LABEL_LEGEND_CONFLICT_RESOLUTION_TYPE = {
  UNKNOWN_WORDS: 'UNKNOWN_WORDS',
  AI_CONFLICT: 'AI_CONFLICT',
}

module.exports = LABEL_LEGEND_CONFLICT_RESOLUTION_TYPE
